import 'css-chunksrc/client/common/resourceAllocationMenu/resources/styles.scss';export default {
  "resources": "_resources_1wvx0_1",
  "row": "_row_1wvx0_5",
  "header": "_header_1wvx0_15",
  "avatar": "_avatar_1wvx0_24",
  "iconBox": "_iconBox_1wvx0_31",
  "icon": "_icon_1wvx0_31",
  "title": "_title_1wvx0_47",
  "name": "_name_1wvx0_54",
  "list": "_list_1wvx0_61",
  "spinner": "_spinner_1wvx0_65"
};